<template>
    <div :class="['alert-panel', `alert-panel--${type}`, noSideMargin ? 'alert-panel--no-side-margin' : '']"
        @click="handlePanelClick"
    >
        <div class="alert-panel__icon">
            <i :class="`icon-${icon}`" />
        </div>
        <div class="alert-panel__content">
            <p class="alert-panel__content-title">{{ title }}</p>
            <p class="alert-panel__content-description">{{ description }}</p>
        </div>
        <div v-if="!hideCloseIcon"
            class="alert-panel__close-icon"
        >
            <i class="icon-cancel"
                @click.stop.prevent="closeAlert"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'alert-panel',
    props: {
        hideCloseIcon: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            required: true,
            validator(value) {
                return [
                    'warning',
                    'error',
                    'success',
                ].includes(value);
            },
        },
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            default: '',
        },
        noSideMargin: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        handlePanelClick() {
            this.$emit('onClick');
        },

        closeAlert() {
            this.$emit('onClose');
        },
    },
};
</script>

<style lang="scss" scoped>
    .alert-panel {
        display: grid;
        grid-template-columns: 52px 1fr 26px;
        border-radius: 8px;
        overflow: hidden;
        grid-gap: 16px;
        cursor: pointer;
        margin: 0 24px;

        &--no-side-margin {
            margin: 20px 0;
        }

        &--warning {
            background-color: $orange-t-90;

            .alert-panel__icon {
                background-color: $selective-yellow-color;
            }
        }

        &--error {
            background-color: $red-t-90;

            .alert-panel__icon {
                background-color: $red-orange-color;
            }
        }

        &--success {
            background-color: $loafer-color;

            .alert-panel__icon {
                background-color: $lima-color;
            }
        }

        &__icon {
            color: $white-color;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
        }

        &__content {
            padding: 16px 8px;

            &-title {
                font-size: 15px;
                color: $black-color;
                font-weight: bold;
                margin: 0;
            }

            &-description {
                font-size: 15px;
                margin: 4px 0 0;
            }
        }

        &__close-icon {
            font-size: 10px;
            color: $black-color;
            padding: 8px;
            cursor: pointer;
            font-weight: bold;
        }
    }
</style>